import {
  createStore,
  MutationTree,
  ActionContext,
  ActionTree,
  GetterTree,
  Store as VuexStore,
  CommitOptions,
  DispatchOptions,
  createLogger
} from "vuex";

import { AuthState, initialState as AuthInitialState, AuthMutations, AuthActionTypes, AuthMutation, AuthActions, authGetter, AuthGetters, authActions, AuthMutationType } from './auth.module';
import { UIState, initialState as UiInitialState, UiMutationType, UiActionTypes, UiMutation, UiMutations, uiGetter, UiGetters, UiActions, uiActions } from "./ui.module";

interface User {
  id: number;
  email: string;
  name: string;
}

export type State = { auth: AuthState; ui: UIState }

const state: State = { auth: AuthInitialState, ui: UiInitialState };


export const MutationTypes = {
  ...AuthMutationType,
  ...UiMutationType
}

export const ActionTypes = { ...AuthActionTypes, ...UiActionTypes };
export type ActionTypesT = typeof ActionTypes;


export type Mutations<S = State> = AuthMutation & UiMutation


const mutations: MutationTree<State> & Mutations = { ...AuthMutations, ...UiMutations }

export type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, "commit">;

export type Actions = AuthActions & UiActions

export const actions: ActionTree<State, State> & Actions = {
  ...authActions,
  ...uiActions
};

export type Getters = AuthGetters & UiGetters

export const getters: GetterTree<State, State> & Getters = {
  ...authGetter,
  ...uiGetter
};

export type Store = Omit<
  VuexStore<State>,
  "commit" | "getters" | "dispatch"
> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>;
  };
} & {
  dispatch<K extends keyof Actions>(
    key: K,
    payload: Parameters<Actions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<Actions[K]>;
};

export const store = createStore({
  state,
  mutations,
  actions,
  getters,
  plugins: [createLogger({
    logActions: true, // Log Actions
    logMutations: true, // Log mutations
  })]
});

export function useStore() {
  return store as Store;
}
